<script setup>
import { ref, watch } from "vue"; // import Swiper core and required modules
import {
  A11y,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper/modules"; // Import Swiper Vue.js components
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import { useRouter } from "vue-router";
import { useTemplateStore } from "@/stores/template";
import commonUtils from "@/utils/commonUtils";

const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay];

const props = defineProps({
  ourPartners: {},
});
const baseUrl = "/api/v3/content/collections/images";
const router = useRouter();
const templateStore = useTemplateStore();
const equipmentType = ref(templateStore.responsive.equipmentType);
watch(
  () => templateStore.responsive.equipmentType,
  (newValue) => {
    equipmentType.value = newValue;
  }
);
</script>
<template>
  <section
    v-if="
      commonUtils.sortByParams(ourPartners, 'sequenceNumber') &&
      commonUtils.sortByParams(ourPartners, 'sequenceNumber').length > 0
    "
    id="our_partners"
    class="section_padding"
  >
    <div class="container">
      <!-- Section Heading -->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="section_heading_center">
            <h2>{{ $t("our-partners") }}</h2>
          </div>
        </div>
      </div>
      <!-- 滚动播放-->
      <!--      <div class="row">-->
      <!--        <div class="col-lg-12">-->
      <!--          <div class="partner_slider_area owl-theme owl-carousel">-->
      <!--            <Swiper-->
      <!--              :autoplay="{-->
      <!--                delay: 1000,-->
      <!--                disableOnInteraction: false, // 用户交互后是否停止自动播放-->
      <!--              }"-->
      <!--              :modules="modules"-->
      <!--              :slides-per-view="equipmentType === 'iphone' ? 6 : 8"-->
      <!--              loop-->
      <!--            >-->
      <!--              <SwiperSlide-->
      <!--                v-for="(-->
      <!--                  ourPartner, ourPartnerIndex-->
      <!--                ) in commonUtils.sortByParams(ourPartners, 'sequenceNumber')"-->
      <!--                :id="ourPartnerIndex"-->
      <!--                :key="ourPartnerIndex"-->
      <!--              >-->
      <!--                <div class="partner_logo">-->
      <!--                  <a :href="ourPartner.links">-->
      <!--                    <div-->
      <!--                      class="partner-link"-->
      <!--                      style="-->
      <!--                        display: flex;-->
      <!--                        flex-direction: column;-->
      <!--                        justify-content: space-around;-->
      <!--                        align-items: center;-->
      <!--                        font-size: 14px;-->
      <!--                      "-->
      <!--                    >-->
      <!--                      <img-->
      <!--                        v-if="-->
      <!--                          ourPartner && ourPartner.icon && ourPartner.icon.url-->
      <!--                        "-->
      <!--                        :src="baseUrl + ourPartner.icon.url"-->
      <!--                        alt="logo"-->
      <!--                        class="logo"-->
      <!--                      />-->
      <!--                      <span class="partner-name">-->
      <!--                        {{ ourPartner.companyName }}</span-->
      <!--                      >-->
      <!--                    </div>-->
      <!--                  </a>-->
      <!--                </div>-->
      <!--              </SwiperSlide>-->
      <!--            </Swiper>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row">
        <div
          v-for="(ourPartner, ourPartnerIndex) in commonUtils.sortByParams(
            ourPartners,
            'sequenceNumber'
          )"
          :key="ourPartnerIndex"
          class="col-2 mg-l-10 mg-t-20"
        >
          <div class="partner_logo">
            <a :href="ourPartner.links">
              <div
                class="partner-link"
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  align-items: center;
                  font-size: 14px;
                "
              >
                <img
                  v-if="
                    ourPartner &&
                    ourPartner.icon &&
                    ourPartner.icon.url &&
                    equipmentType === 'iphone'
                  "
                  :src="baseUrl + ourPartner.icon.url"
                  alt="logo"
                  class="logo"
                  style="width: 100px; height: 80px; object-fit: contain"
                /><img
                  v-else-if="
                    ourPartner &&
                    ourPartner.icon &&
                    ourPartner.icon.url &&
                    equipmentType !== 'iphone'
                  "
                  :src="baseUrl + ourPartner.icon.url"
                  alt="logo"
                  class="logo"
                  style="width: 80px; height: 60px; object-fit: contain"
                />
                <span class="partner-name"> {{ ourPartner.companyName }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
